<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="full-middle"
      no-padding
      :confirm-loading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>打印标签</span>
    </template>
    <template #content>
      <gj-alert class="gj-mt16 gj-mlr20" show-icon>
        <template #title>
          如果您的标签规格一致、打印数量与单据量一致，可以尝试快速填表功能。
        </template>
      </gj-alert>
      <el-form
          ref="form"
          :model="form"
          :inline="true"
          style="padding: 16px 20px 0 20px;">
        <div class="print-tip">快速填表：</div>
        <el-form-item
            label="纸张类型"
            prop="paperType">
          <gj-select
              v-model="form.paperType"
              :options="paperLabelOption"
              width="180px"
              :clearable="false"
          ></gj-select>
        </el-form-item>
        <!-- <el-form-item
            style="margin-left: 20px;">
          <gj-checkbox
              v-model="form.autoPrintNum"
              @input="autoPrintNumInput"
          >打印量等于单据量</gj-checkbox>
        </el-form-item> -->
        <div style="margin-left: 4px;">
          <el-form-item
              label=" "
              prop="madeInChina"
              label-width="70px">
              <gj-checkbox
                v-model="form.madeInChina"
                style="margin-right: 10px;"
            ></gj-checkbox>
            打印Made in China字样
          </el-form-item>
          <el-form-item
              style="margin-left: 19px;">
            <gj-checkbox
                v-model="form.skuOrName"
                style="margin-right: 10px;"
            ></gj-checkbox>
            <gj-select
                v-model="form.skuOrNameType"
                :options="skuOrNameTypeOption"
                width="130px"
                :clearable="false"
            ></gj-select>
          </el-form-item>
          <el-form-item
              style="margin-left: 19px;">
            <gj-checkbox
                v-model="form.isCustomContent"
                style="margin-right: 10px;"
            ></gj-checkbox>
            自定义内容
          </el-form-item>
        </div>
        <div v-if="form.isCustomContent" style="margin:0 0 10px 70px;">
          <gj-input 
            v-model="form.customContent"
            show-word-limit
            :disabled="!form.isCustomContent"
            placeholder="请输入自定义内容"
            width="100%"
            maxlength="50">
          </gj-input>
        </div>
        <gj-table
            :index="false"
            name="printProductLabel"
            :data="form.items"
            :columns="columns"
            :offset-height="54"
            :show-pagination="false">
          <template v-slot:header:paperType>
            <div class="paper-type">纸张类型</div>
          </template>
          <template v-slot:printNum="{ index }">
            <el-form-item
                :prop="`items.${index}.printNum`"
                :rules="[
                  { required: true, message: '请输入打印数量', trigger: ['change'] },
                  $gjReRule(RE.pt, '请输入正整数')
                ]"
                class="gj-table-item">
              <gj-input
                  v-model.number="form.items[index].printNum"
                  v-number.int
                  maxlength="5"
                  width="120px">
              </gj-input>
            </el-form-item>
          </template>
          <template v-slot:msku="{ row }">
            <div>
              <gj-tooltip :content="row.msku" :text-line="1">
                {{row.msku | defaultShow}}
              </gj-tooltip>
            </div>
            <div>
              <gj-tooltip :content="row.fnsku" :text-line="1">
                {{row.fnsku | defaultShow}}
              </gj-tooltip>
            </div>
          </template>
          <template v-slot:op="{ index }">
            <gj-button type="text" @click="deleteItem(index)">删除</gj-button>
          </template>
        </gj-table>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, modalMixIn} from "@/minxins";
  import {isMeaningful, isMeaningless} from "@/utils/common";
  import {printListingLabels} from "@/api/sale";
  import {getPrintSimpleListings} from "@/api/common";

  export default {
    name: "app-print-listing-label-modal",
    mixins: [modalMixIn, formRuleMixin],
    props: {
      items: {
        type: Array,
        required: true
      },
      ids: {
        type: Array,
        default: () => {
          return []
        }
      },
      isFasin: {
        type: Boolean,
        default: false
      }
    },
    created() {
      this.updateLocalStorage('get')
      if (this.isFasin) {
        let params = {
          listingIds: this.ids,
          printBizType: 'listing'
        }
        getPrintSimpleListings(params).then(data => {
          this.form.items = data.filter(e => e.fnsku);
          if (this.form.items?.length === 0) {
            this.$gjMessage.error('请至少选择一个存在FNSKU的产品');
          }
        })
      } else {
        this.form.items = this.items.filter(e => e.fnsku);
        if (this.form.items?.length === 0) {
          this.$gjMessage.error('请至少选择一个存在FNSKU的产品');
        }
      }
    },
    data() {
      return {
        form: {
          paperType: 1,
          skuOrName: false,
          autoPrintNum: false,
          englishTitle: true,
          madeInChina: true,
          isCustomContent: false,
          customContent: "",
          skuOrNameType: 'productName',
          items: []
        },
        skuOrNameTypeOption: [
          {id: 'productName', text: '打印产品名称'},
          {id: 'sku', text: '打印SKU'},
        ],
        columns: [
          {id: 'picture', header: '图片', field: 'picture:imageUrl', width: '60px'},
          {id: 'msku', header: 'MSKU/FNSKU', field: 'slot:msku', width: '200px'},
          {id: 'title', header: '条码内容', field: 'title', overflowLine: 2, minWidth: '200px'},
          {id: 'printNum', header: '打印数量', field: 'slot:printNum', width: '150px'},
        ],
        paperLabelOption: [
          {id: 1, text: "热敏纸（50*30）单排"},
          {id: 2, text: "热敏纸（100*30）双排"},
          {id: 3, text: "每张US信纸最多30个标签（1英寸x2-5/8英寸）"},
          {id: 4, text: "每页纸最多21个标签（A4纸，63.5毫米x38.1毫米）"},
          {id: 5, text: "每页纸最多24个标签（A4纸，63.5毫米x33.9毫米）"},
          {id: 6, text: "每页纸最多24个标签（A4纸，64.6毫米x33.8毫米）"},
          {id: 7, text: "每页纸最多24个标签（A4纸，66毫米x33.9毫米）"},
          {id: 8, text: "每页纸最多24个标签（A4纸，66毫米x35毫米）"},
          {id: 9, text: "每页纸最多24个标签（A4纸，70毫米x36毫米）"},
          {id: 10, text: "每页纸最多24个标签（A4纸，70毫米x37毫米）"},
          {id: 11, text: "每页纸最多27个标签（A4纸，63.5毫米x29.6毫米）"},
          {id: 12, text: "每页纸最多40个标签（A4纸，52.5毫米x29.7毫米）"},
          {id: 13, text: "每页纸最多44个标签（A4纸，48.5毫米x25.4毫米）"},
        ],
      }
    },
    methods: {
      // 设置打印缓存 type: 'get' | 'set"
      updateLocalStorage(type){
        let form = {
          paperType: Number(this.form.paperType),
          madeInChina: this.form.madeInChina,
          skuOrName: this.form.skuOrName,
          skuOrNameType: this.form.skuOrNameType,
        }
        const opt = {
          get: () => {
            let formData = window.localStorage.getItem("listingPrintModal");
            if(isMeaningful(formData)){
              this.form = Object.assign(this.form, JSON.parse(formData))
            }
          },
          set: () => {
            let strForm = JSON.stringify(form);
            window.localStorage.setItem("listingPrintModal",strForm)
          },
        }
        opt[type]()
      },
      deleteItem(index) {
        this.form.items.splice(index, 1);
      },
      confirm() {
        if (isMeaningless(this.form.items) || this.form.items.length === 0) {
          this.$gjMessage.error('产品不能为空');
        }
        if (this.$gjFormValidate()) {
          this.updateLocalStorage('set');
          this.confirmLoading = true;
          printListingLabels({
            isNew: true,
            isMadeInChina: this.form.madeInChina,
            printPaperType: this.form.paperType,
            labelsItems: this.form.items.map(item => {
              return {
                sku: this.form.skuOrName ? (this.form.skuOrNameType === 'productName' ? item.productName : item.sku) : null,
                code: item.fnsku,
                quantity: item.printNum,
                content: item.title,
                customContent: this.form.customContent,
              }
            })
          })
            .then((url) => {
              window.open(url);
              this.$gjDestroy();
            })
            .complete(() => this.confirmLoading = false);
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .print-tip {
    display: inline-block;
    margin-top: 8px;
    font-size: 12px;
    color: #666666;
    margin-right: 12px;
  }
  .paper-type {
    padding-left: 100px;
  }
  /deep/ .el-form-item {
    margin-bottom: 10px;
  }
  .gj-mt16 {
    margin-top: 16px;
  }
  .gj-mlr20 {
    margin-left: 20px;
    margin-right: 20px;
  }
</style>

